import { render, staticRenderFns } from "./OurClients.vue?vue&type=template&id=11dd27de&scoped=true&"
import script from "./OurClients.vue?vue&type=script&lang=js&"
export * from "./OurClients.vue?vue&type=script&lang=js&"
import style0 from "./OurClients.vue?vue&type=style&index=0&id=11dd27de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd27de",
  null
  
)

export default component.exports